import { Link } from "react-router-dom";
import { getTypeCount, typeLabels, type MediaType } from "@/utils/media";

const categories: {
  type: MediaType;
  icon: string;
  desc: string;
  accent: string;
}[] = [
  {
    type: "movie",
    icon: "ri-film-line",
    desc: "亚洲各国口碑佳作，剧情、悬疑、爱情一网打尽",
    accent: "bg-primary-50 text-primary-600",
  },
  {
    type: "drama",
    icon: "ri-tv-2-line",
    desc: "日韩古装与现代剧集，追剧党的不二之选",
    accent: "bg-accent-50 text-accent-600",
  },
  {
    type: "variety",
    icon: "ri-mic-2-line",
    desc: "美食、选秀与旅行综艺，轻松一刻随时开看",
    accent: "bg-secondary-100 text-secondary-700",
  },
];

export default function CategoryQuickLinks() {
  return (
    <section className="mx-auto w-full px-4 md:px-6">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {categories.map((item) => (
          <Link
            key={item.type}
            to={`/category/${item.type}`}
            className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 md:p-5"
          >
            <span
              className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-lg ${item.accent}`}
            >
              <i className={`${item.icon} text-2xl`}></i>
            </span>
            <span className="min-w-0">
              <span className="flex items-center gap-1.5 text-base font-semibold text-foreground-950">
                {typeLabels[item.type]}
                <i className="ri-arrow-right-line text-sm text-foreground-400 transition-transform group-hover:translate-x-1"></i>
              </span>
              <span className="mt-1 block truncate text-xs text-foreground-500">
                {item.desc}
              </span>
              <span className="mt-1 block text-xs text-foreground-400">
                共 {getTypeCount(item.type)} 部作品
              </span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}